export default __webpack_public_path__ + "static/media/arrow.9188dbe4.svg";